jQuery(function ($) {
  const section = $('[data-contact]');
  const inputs = section.find('input, textarea');

  inputs.on('focus', function () {
    const inputWrap = $(this).parents('.form-field');

    inputWrap.addClass('has-focus');
  });

  inputs.on('blur', function () {
    const input = $(this);
    const inputWrap = input.parents('.form-field');

    inputWrap.removeClass('has-focus');

    if (input.val() !== '') {
      inputWrap.addClass('has-value');
    } else {
      inputWrap.removeClass('has-value');
    }
  });

  $(document).on('wpcf7mailsent', function () {
    $.each(inputs, function () {
      const inputWrap = $(this).parents('.form-field');

      inputWrap.removeClass('has-value');
    });
  });
});
